import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons.svg'


const _withScopeId = n => (_pushScopeId("data-v-a11d5454"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + '#icon-whatsapp'
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://wa.link/qax9zx" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "layout-btn d-flex justify-content-center align-items-center" }, [
    /*#__PURE__*/_createElementVNode("svg", null, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": _hoisted_1 })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nav_bar = _resolveComponent("nav-bar")!
  const _component_count_down = _resolveComponent("count-down")!
  const _component_launch = _resolveComponent("launch")!
  const _component_Header = _resolveComponent("Header")!
  const _component_download = _resolveComponent("download")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.nav)
      ? (_openBlock(), _createBlock(_component_nav_bar, {
          key: 0,
          nav: _ctx.navHandler,
          launch: _ctx.launchHandler,
          countdown: _ctx.countHandler
        }, null, 8, ["nav", "launch", "countdown"]))
      : _createCommentVNode("", true),
    (_ctx.countdown)
      ? (_openBlock(), _createBlock(_component_count_down, {
          key: 1,
          close: _ctx.countHandler
        }, null, 8, ["close"]))
      : _createCommentVNode("", true),
    (_ctx.launch)
      ? (_openBlock(), _createBlock(_component_launch, {
          key: 2,
          close: _ctx.launchHandler
        }, null, 8, ["close"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Header, {
      nav: _ctx.navHandler,
      countdown: _ctx.countHandler,
      launch: _ctx.launchHandler
    }, null, 8, ["nav", "countdown", "launch"]),
    _createElementVNode("main", null, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      (_ctx.download)
        ? (_openBlock(), _createBlock(_component_download, {
            key: 0,
            countdown: _ctx.countHandler
          }, null, 8, ["countdown"]))
        : _createCommentVNode("", true),
      _hoisted_2
    ]),
    (_ctx.footer)
      ? (_openBlock(), _createBlock(_component_Footer, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}